import { render } from "./AdminDate.vue?vue&type=template&id=3111b268"
import script from "./AdminDate.vue?vue&type=script&lang=js"
export * from "./AdminDate.vue?vue&type=script&lang=js"

import "./AdminDate.vue?vue&type=style&index=0&id=3111b268&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__